<template>
<!-- eslint-disable max-len -->
<span>
  <transition leave-active-class="animated fadeOut">
    <top-bar v-if="showBars">Wait for Team</top-bar>
  </transition>

  <transition leave-active-class="animated slideOutLeft">
    <player v-if="showPlayer" angled></player>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <narrator-bubble v-if="showNarratorBubble" id="narrator-bubble" width="880px">
      Let's wait for the rest of
      your team to show up...
    </narrator-bubble>
  </transition>

  <transition enter-active-class="animated slideInRight" leave-active-class="animated fadeOutRight">
    <narrator v-if="showNarrator"></narrator>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated slideOutRight">
    <div v-if="showOtherPlayers" class="other-players">
      <div v-for="(player, i) in paddedOtherPlayers" :key="`player-${i}`" class="other-player" :style="{ left: `${315 + 300 * i}px` }">
        <transition enter-active-class="animated fadeIn">
          <span v-if="player.character.image" key="here">
            <img :src="resolveAssetPath(player.character.image, 'characters')">
            <team-statement-bubble class="statement-bubble">
              {{ getWelcomeMessage(player, i) }}
            </team-statement-bubble>
          </span>

          <!-- TODO: these look bad right now
          <img v-else :src="resolveAssetPath('TM_characterBlank.png', 'ui/customer')" key="absent">
          -->
        </transition>
      </div>
    </div>
  </transition>

  <transition leave-active-class="animated fadeOut">
    <bottom-bar v-if="showBars && !(showNarratorPanel && allPlayersHere)"
      :next="showButton ? goToWait : undefined"
      :show-player="showPlayerName"
    ></bottom-bar>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <narrator-panel v-if="showNarratorPanel && allPlayersHere" id="narrator-panel" :next="navigateWithAnimation" :character="narrator">
      Looks like the whole group is here.
      Let's begin!
    </narrator-panel>
  </transition>
</span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import TopBar from '../ui/TopBar';
import Player from '../ui/Player';
import TeamStatementBubble from '../ui/TeamStatementBubble';
import Narrator from '../ui/Narrator';
import NarratorBubble from '../ui/NarratorBubble';
import NarratorPanel from '../ui/NarratorPanel';
import BottomBar from '../ui/BottomBar';

export default {
  components: {
    TopBar,
    Player,
    TeamStatementBubble,
    Narrator,
    NarratorBubble,
    NarratorPanel,
    BottomBar
  },
  data() {
    return {
      showBars: true,
      showPlayerName: true,
      showNarrator: false,
      showPlayer: true,
      showOtherPlayers: false,
      showNarratorBubble: false,
      showButton: false,
      showNarratorPanel: false,
      intervalID: null,
      failCount: 0,
    };
  },
  computed: {
    ...mapGetters([
      'otherPlayers',
      'narrator',
      'group',
      'updateGroup',
      'users',
      'allPlayersHere'
    ]),
    paddedOtherPlayers() {
      return this.otherPlayers.concat(
        [1, 2, 3, 4]
          .map(() => ({
            character: {},
            role: {},
            groupRole: {},
            decision: {},
            groupDecision: {}
          }))
          .slice(0, 4 - this.otherPlayers.length)
      );
    },
    // allPlayersHere() {
    //   return this.paddedOtherPlayers.every(({ character: { image } }) => image);;
    // },
  },
  methods: {
    ...mapActions([
      'getMyGroup',
      'pollGroup'
    ]),
    getWelcomeMessage(player, index) {
      if (!player || !(player.character)) return '';
      const u = this.users[player._id];
      const playerName = (u ? (u.firstName || u.email) : player.character.title);
      switch (index % 4) {
        case 0: return `${playerName} here`;
        case 1: return `Hi, this is ${playerName}`;
        case 2: return `I am ${playerName}`;
        case 3: return `My name is ${playerName}`;
        default: return 'Hi there.';
      }
    },
    async goToWait() {
      this.showNarratorBubble = false;
      this.showNarrator = false;
      this.showButton = false;
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.showNarratorPanel = true;
      this.showOtherPlayers = true;
    },
    async navigateWithAnimation() {
      this.showPlayer = false;
      this.showOtherPlayers = false;
      this.showNarratorPanel = false;
      this.showPlayerName = false;
      await new Promise(resolve => setTimeout(resolve, 1250));
      this.$router.nextGameState();
    },
    async poll() {
      try {
        await this.pollGroup();
        this.failCount = 0;
      } catch (err) {
        this.failCount += 1;
        if (this.failCount > 3) {
          if (await this.$router.handleGameError(err)) return;
          this.$router.showGameErrorCritical();
        }
      }
    }
  },
  watch: {
    async updateGroup(newValue) {
      if (!newValue) return;

      try {
        const { _id: groupId } = this.group;
        await this.getMyGroup({ groupId });
      } catch (err) {
        if (await this.$router.handleGameError(err)) return;
        this.$router.showGameErrorCritical();
      }
    }
  },
  async mounted() {
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.showNarrator = true;
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.showNarratorBubble = true;
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.showButton = true;
    if (this.group.players.length > 1) {
      this.intervalID = window.setInterval(this.poll, 5000);
    }
  },
  beforeDestroy() {
    if (this.intervalID != null) {
      window.clearInterval(this.intervalID);
    }
  }
};
</script>

<style lang="scss" scoped>
#narrator-bubble {
  top: 155px;
  left: 350px;
}
.other-players {
  bottom: -125px;
  width: 100%;
  height: 100%;
  position: absolute;
}
.other-player {
  position: absolute;
  transform: scale(0.85);
}
.other-player img {
  transform: scaleX(-1);
}
.statement-bubble {
  top: -70px;
  left: 90px;
  transform: scale(1.177);
}
#narrator-panel {
  left: 30px;
  bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/WaitForTeam.vue